import classNames from 'classnames'
import { Formik, FormikErrors, useFormik } from 'formik'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { FC, ReactElement, useEffect, useState } from 'react'
import { LegacyModal } from 'src/components/Modal/LegacyModal'
import { useGetSubjectQuery } from 'src/api/endpoints/subjects/api'
import { requireField } from 'src/constants/constants'
import {
    getFormErrorMessage,
    isFormFieldValid,
} from 'src/pages/Materials/components/MaterialEditingPopup/Content/MaterialEditingPopupContent'
import { skipToken } from '@reduxjs/toolkit/query'

export type SubjectUpdateForm = {
    name: string;
}

interface SubjectUpdateButtonProps {
    id: number;
    onSubmit?: (id: number, values: SubjectUpdateForm) => Promise<void>;
}

export const SubjectUpdateButton: FC<SubjectUpdateButtonProps> = (props: SubjectUpdateButtonProps): ReactElement => {
    const [isModalOpen, setModalOpen] = useState(false)
    
    const { data: subject, isLoading: isSubjectLoading } = useGetSubjectQuery(
        isModalOpen
        ? { params: { subjectId: props.id } }
        : skipToken,
    )
    
    const formik: Formik<Partial<SubjectUpdateForm>> = useFormik<Partial<SubjectUpdateForm>>({
        initialValues: {},
        validate: (values: Partial<SubjectUpdateForm>): FormikErrors<any> => {
            const errors: FormikErrors<Partial<SubjectUpdateForm>> = {}
            
            if (!values.name || !values.name.trim()) {
                errors.name = requireField
            }
            
            return errors
        },
        onSubmit: async (values: Partial<SubjectUpdateForm>): Promise<void> => {
            setLoading(true)
            
            if (props.onSubmit) {
                await props.onSubmit(props.id, values as SubjectUpdateForm)
            }
            
            setLoading(false)
            setModalOpen(false)
        },
    })
    
    const [isLoading, setLoading] = useState(false)
    
    useEffect((): void => {
        if (isSubjectLoading || !subject) return
        
        formik.setValues({ name: subject.name }, true)
    }, [isSubjectLoading, subject])
    
    const onModalClose: VoidFunction = (): void => setModalOpen(false)
    const onModalOpen: VoidFunction = (): void => setModalOpen(true)
    
    return (
        <>
            <LegacyModal
                header={'Изменение предмета'}
                visible={isModalOpen}
                onHide={onModalClose}
            >
                <form onSubmit={formik.handleSubmit}>
                    <div className="field">
                        <span className="p-float-label">
                            <InputText
                                disabled={isSubjectLoading}
                                id="name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                className={classNames('w-full', {
                                    'p-invalid': isFormFieldValid(formik, 'name'),
                                })}
                            />
                            <label
                                htmlFor="comment"
                                className={classNames({
                                    'p-error': isFormFieldValid(formik, 'name'),
                                })}
                            >
                                Название предмета
                            </label>
                        </span>
                        {getFormErrorMessage(formik, 'name')}
                    </div>
                    
                    <Button
                        disabled={isSubjectLoading}
                        loading={isLoading}
                        type="submit"
                        label="Сохранить"
                        className={'w-auto'}
                    />
                </form>
            </LegacyModal>
            
            <Button icon="pi pi-file-edit" onClick={onModalOpen} />
        </>
    )
}
